module.exports = __webpack_public_path__ + "static/media/questionnaire-survey-logo.ea67cc9d.png";